// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/surveypage/SurveyCreatePage.css
// module id = 1417
// module chunks = 0